/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convert ${i?.category} units instantly and accurately. Free online ${i?.category} converter that works in your browser — no signup.`)
};

const es_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convierte unidades de ${i?.category} al instante y con precisión. Conversor de ${i?.category} en línea gratuito que funciona en tu navegador — sin registro.`)
};

const de_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rechnen Sie ${i?.category}-Einheiten sofort und präzise um. Kostenloser Online-${i?.category}-Umrechner, der direkt im Browser funktioniert — keine Anmeldung erforderlich.`)
};

const nl_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converteer ${i?.category} eenheden direct en nauwkeurig. Gratis online ${i?.category} convertor die in uw browser werkt — geen registratie.`)
};

const fr_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convertissez instantanément et précisément les unités ${i?.category}. Convertisseur ${i?.category} gratuit en ligne qui fonctionne dans votre navigateur — aucune inscription.`)
};

const it_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converti le unità di ${i?.category} istantaneamente e accuratamente. Convertitore di ${i?.category} online gratuito che funziona nel tuo browser — nessuna iscrizione.`)
};

const pt_br2_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converta unidades de ${i?.category} instantaneamente e com precisão. Conversor de ${i?.category} online gratuito que funciona no seu navegador — sem necessidade de inscrição.`)
};

const pt_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Converter unidades de ${i?.category} instantânea e precisamente. Conversor ${i?.category} online gratuito que funciona no seu navegador — sem necessidade de registo.`)
};

const ja_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.category}単位をすぐに正確に変換します。ブラウザで動作する無料オンライン${i?.category}コンバーター — サインアップ不要。`)
};

const zh_uc_cat_meta_description = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ category: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_meta_description = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_meta_description", locale)
	if (locale === "en") return en_uc_cat_meta_description(inputs)
	if (locale === "es") return es_uc_cat_meta_description(inputs)
	if (locale === "de") return de_uc_cat_meta_description(inputs)
	if (locale === "nl") return nl_uc_cat_meta_description(inputs)
	if (locale === "fr") return fr_uc_cat_meta_description(inputs)
	if (locale === "it") return it_uc_cat_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_meta_description(inputs)
	if (locale === "pt") return pt_uc_cat_meta_description(inputs)
	if (locale === "ja") return ja_uc_cat_meta_description(inputs)
	return zh_uc_cat_meta_description(inputs)
};